var map = {
	"./2023-06-03.json": "/bR7",
	"./2023-07-29.json": "IOcs",
	"./2023-08-03.json": "H0k7",
	"./2023-08-11.json": "D1C9",
	"./2023-08-23.json": "CcT1",
	"./2023-09-18.json": "v1XT",
	"./2023-10-12.json": "7wfK",
	"./2023-11-10.json": "U8SU",
	"./2023-11-22.json": "4w61",
	"./2023-12-08.json": "aUA7",
	"./2023-12-21.json": "R2wc",
	"./2024-01-10.json": "k/At",
	"./2024-01-23.json": "FtO6",
	"./2024-02-04.json": "sMHE",
	"./2024-02-23.json": "nFKt",
	"./2024-03-04.json": "VZgP",
	"./2024-03-14.json": "UMYu",
	"./2024-03-19.json": "68aw",
	"./2024-03-28.json": "96CF",
	"./2024-04-15.json": "eP5L",
	"./2024-04-25.json": "0uHt",
	"./2024-05-23.json": "wQ5t",
	"./2024-05-27.json": "ED08",
	"./2024-06-13.json": "Jim+",
	"./2024-06-28.json": "xM8g",
	"./2024-07-11.json": "vZQv",
	"./2024-07-22.json": "OOYK",
	"./2024-07-30.json": "OTiI",
	"./2024-08-08.json": "dzxx",
	"./2024-08-17.json": "jPZq",
	"./2024-08-22.json": "POz2",
	"./2024-08-27.json": "gYbm",
	"./2024-09-11.json": "Lezn",
	"./2024-09-23.json": "6qxj",
	"./2024-10-09.json": "esMP",
	"./2024-10-11.json": "McI3",
	"./2024-10-16.json": "OleB",
	"./2024-10-23.json": "pxxT",
	"./2024-10-24.json": "SHTI",
	"./2024-10-30.json": "Gmgm",
	"./2024-11-07.json": "1koR",
	"./2024-11-08.json": "Np/o",
	"./2024-11-15.json": "yLee",
	"./2024-11-19.json": "Jf4T",
	"./2024-12-06.json": "2XCm",
	"./2024-12-17.json": "DOPU",
	"./2025-01-21.json": "/m37",
	"./2025-01-22.json": "kUTM",
	"./2025-02-10.json": "rMBC",
	"./2025-03-13.json": "MNmP",
	"./2025-04-25.json": "pNhc",
	"./2025-05-14.json": "MrPT",
	"./2025-06-12.json": "I6Rl",
	"./2025-06-17.json": "XMQV",
	"./2025-06-30.json": "EwTG",
	"./2025-07-09.json": "FF3k",
	"./2025-07-11.json": "+rRL",
	"./2025-08-21.json": "693+",
	"./2025-09-01.json": "JH82",
	"./2025-09-10.json": "aYNr",
	"./2025-10-09.json": "AxcT",
	"./2025-10-11.json": "MCA4",
	"./2025-11-13.json": "hdtI",
	"./2025-11-25.json": "ureo",
	"./2025-12-09.json": "E7ys",
	"./2025-12-16.json": "c8/f",
	"./2025-12-18.json": "sqvz",
	"./2026-01-05.json": "AUPB",
	"./2026-01-22.json": "38eu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yEDo";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog \.json$
// module id = yEDo
// module chunks = 3